module.exports = __webpack_public_path__ + "static/media/door07.4e5fdd5e.png";